export default function readMoreButtonsController() {
  const readMoreButtons = document.getElementsByClassName('read-more-btn');

  if (readMoreButtons.length === 0) {
    return;
  }

  for (const button of readMoreButtons) {
    const container = button.closest('.read-more-container');

    if (!container) {
      return;
    }

    const shortContent = container.querySelector('.read-more-content--short');
    const longContent = container.querySelector('.read-more-content--long');

    if (!shortContent || !longContent) {
      return;
    }

    button.addEventListener('click', function () {
      if (shortContent.style.display == 'none') {
        shortContent.style.removeProperty('display');
        longContent.style.display = 'none';
      } else {
        shortContent.style.display = 'none';
        longContent.style.removeProperty('display');
      }
    });
  }
}
